
define('jst!onboarding_app/tour/_step4',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%- translations.onboarding.settings.title %></h1>\n\n<p><%- translations.onboarding.settings.description %></p>\n');
 });

